import React from "react";
import {useState,useEffect,useRef } from 'react';
import { LineChart,BarChart,AreaChart,Rectangle,Bar, Line,Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import axios from "axios";
import configData from "../config.json";
import {Link} from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { useReactToPrint } from 'react-to-print';
import { format } from "date-fns";

const BsecHrDashboard=()=>{
    if(localStorage.getItem('branchID')===null){
        window.location.replace('/hris');
    }
    const [misData,setMisData]=useState([]);
    const [noResults, setNoResults] = useState(false);
    const [attenDataSum,setAttenDataSum]=useState([]);

    const [startDate, setStartDate] = useState(() => {
            const today = new Date();
            return today.toISOString().split('T')[0];
            });
    const [endDate, setEndtDate] = useState(() => {
            const today = new Date();
            return today.toISOString().split('T')[0];
            });

    useEffect(() => {
      const getMisData = async () => {
        const response=await axios.get(configData.SERVER_URL+`/bsecHrDashboard/${localStorage.getItem('branchID')}`)
        setMisData(response.data);
      };
      getMisData();

    }, []);

    
    
    const handleSubmit=async(e)=>{
        e.preventDefault();

        if (!startDate || !endDate) {
            alert('Dates required.');
            return;
        }  
        
        if (startDate > endDate) {
            alert('Invalid Date Range.');
            return;
        }

        try {
        const res = await axios.get(configData.SERVER_URL+`/lateReport/${startDate}/${endDate}/${localStorage.getItem('branchID')}`);
        setAttenDataSum(res.data);
      
        if (res.data.length === 0) {
            setNoResults(true);
        } else {
            setNoResults(false);
        }
        } catch (error) {
            console.error('Search error:', error);
        }   
    }

    const printDiv = () => {

    const printContent = document.getElementById('printDiv_Late').innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
    };


    return(
        <>
        <div className="container" style={{marginTop:50}}></div>
            <div className="row well py-5">
                <div className="col-xl-12 col-sm-12 mb-3" >
                  <div className="card border-0 shadow-lg overflow-hidden" style={{ borderRadius: "18px",}}>
  {/* Header */}
  <div
    className="card-header d-flex justify-content-between align-items-center"
    style={{ background: "linear-gradient(135deg, #198754, #20c997)", padding: "18px 25px", border: "none", color: "#fff",}}
  >
    <div>
      <h3 className="mb-0 fw-bold">Attendance Summary</h3>
      <small>Daily employee attendance overview</small>
    </div>

    <div
      className="px-3 py-2"
      style={{ backgroundColor: "rgba(255,255,255,0.2)", borderRadius: "10px",fontWeight: "600", }}>
      Total Records: {misData?.length || 0}
    </div>
  </div>

  {/* Body */}
  <div className="card-body" style={{ backgroundColor: "#f8f9fa", padding: "25px",}}>
    <div className="table-responsive">
      <table className="table table-hover align-middle table-bordered"
        style={{ borderRadius: "12px", overflow: "hidden", backgroundColor: "#fff",}}
      >
        <thead style={{ backgroundColor: "#198754", color: "#fff", textAlign: "center", verticalAlign: "middle", }} >
          <tr>
            <th>Organization</th>
            <th>Date</th>
            <th>Total Employee</th>

            <th>Present</th>
            <th>Present %</th>

            <th>Late</th>
            <th>Late %</th>

            <th>Leave</th>
            <th>Leave %</th>

            <th>Absent</th>
            <th>Absent %</th>
          </tr>
        </thead>

        <tbody>
          {misData &&
            misData.length > 0 &&
            misData.map((data, index) => (
              <tr key={index}>
                <td className="fw-semibold">
                  {data.branchcode}
                </td>

                <td>{data.eventDate}</td>

                <td>
                  <span className="badge bg-dark px-3 py-2">
                    {data.total_emp}
                  </span>
                </td>

                {/* Present */}
                <td className="fw-bold text-success">
                  {data.present_count}
                </td>

                <td>
                  <div className="d-flex align-items-center gap-2">
                    <div className="progress w-100" style={{ height: "8px" }} >
                      <div className="progress-bar bg-success" style={{ width: `${data.present_Per}%`, }}> </div>
                    </div>

                    <small className="fw-semibold">
                      {data.present_Per}%
                    </small>
                  </div>
                </td>

                {/* Late */}
                <td className="fw-bold text-primary">
                  {data.late_count}
                </td>

                <td>
                  <div className="d-flex align-items-center gap-2">
                    <div className="progress w-100" style={{ height: "8px" }}>
                      <div  className="progress-bar bg-primary" style={{ width: `${data.late_Per}%`, }}></div>
                    </div>

                    <small className="fw-semibold">
                      {data.late_Per}%
                    </small>
                  </div>
                </td>

                {/* Leave */}
                <td className="fw-bold text-warning">
                  {data.leave_count}
                </td>

                <td>
                  <div className="d-flex align-items-center gap-2">
                    <div className="progress w-100" style={{ height: "8px" }} >
                      <div className="progress-bar bg-warning" style={{ width: `${data.leave_Per}%`, }}></div>
                    </div>

                    <small className="fw-semibold">
                      {data.leave_Per}%
                    </small>
                  </div>
                </td>

                {/* Absent */}
                <td className="fw-bold text-danger">
                  {data.absent_count}
                </td>

                <td>
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="progress w-100"
                      style={{ height: "8px" }}
                    >
                      <div
                        className="progress-bar bg-danger"
                        style={{
                          width: `${data.absent_Per}%`,
                        }}
                      ></div>
                    </div>

                    <small className="fw-semibold">
                      {data.absent_Per}%
                    </small>
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>

    {/* No Data */}
    {misData?.length === 0 && (
      <div className="alert alert-warning text-center mt-3">
        No attendance data found.
      </div>
    )}
  </div>
</div>
                </div>  
                <div className="col-xl-12 col-sm-12 mb-3">
                    <div className="card shadow border-0" id="printDiv_Late"
                    style={{ background: "#fff", borderRadius: "18px", overflow: "hidden", }}>
  {/* Header */}
  <div
    className="card-header d-flex justify-content-between align-items-center"
    style={{
      background: "linear-gradient(135deg, #0dcaf0, #0d6efd)",
      color: "#fff",
      padding: "18px 25px",
      border: "none",
    }}
  >
    <div>
      <h3 className="mb-0 fw-bold">Late Summary Report</h3>
      <small>Employee late attendance statistics</small>
    </div>

    <button
      type="button"
      className="btn btn-light"
      onClick={printDiv}
      style={{
        borderRadius: "50px",
        padding: "10px 18px",
        fontWeight: "600",
      }}
    >
      <Icon.Printer className="me-2" />
      Print
    </button>
  </div>

  {/* Filter Section */}
  <div className="card-body">
    <div
      className="row g-3 align-items-end mb-4 p-3"
      style={{
        backgroundColor: "#f8f9fa",
        borderRadius: "12px",
      }}
    >
      <div className="col-lg-4 col-md-6">
        <label className="form-label fw-semibold text-secondary">
          Start Date
        </label>

        <input
          type="date"
          className="form-control shadow-sm"
          name="startDate"
          id="startDate"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          style={{
            borderRadius: "10px",
            height: "45px",
          }}
        />
      </div>

      <div className="col-lg-4 col-md-6">
        <label className="form-label fw-semibold text-secondary">
          End Date
        </label>

        <input
          type="date"
          className="form-control shadow-sm"
          name="endDate"
          id="endDate"
          value={endDate}
          onChange={(e) => setEndtDate(e.target.value)}
          style={{
            borderRadius: "10px",
            height: "45px",
          }}
        />
      </div>

      <div className="col-lg-2 col-md-4">
        <button
          type="button"
          className="btn btn-primary w-100 shadow-sm"
          onClick={(e) => handleSubmit(e)}
          style={{
            borderRadius: "10px",
            height: "45px",
            fontWeight: "600",
          }}
        >
          <Icon.Search className="me-2" />
          Search
        </button>
      </div>
    </div>

    {/* No Data */}
    {noResults && (
      <div className="alert alert-warning text-center fw-semibold">
        No results found.
      </div>
    )}

    {/* Table */}
    <div className="table-responsive">
      <table className="table table-hover align-middle table-bordered">
        <thead
          style={{
            background: "#0d6efd",
            color: "#fff",
          }}
        >
          <tr className="text-center">
            <th>SL</th>
            <th>Department</th>
            <th>Emp Code</th>
            <th>Employee Name</th>
            <th>09:00 - 09:15</th>
            <th>09:15 - 09:30</th>
            <th>09:30 Above</th>
            <th>Total Late</th>
          </tr>
        </thead>

        <tbody>
          {attenDataSum &&
            attenDataSum.length > 0 &&
            attenDataSum.map((data, index) => (
              <tr key={index}>
                <td>{index + 1}</td>

                <td>{data.deptName}</td>

                <td>{data.empCode}</td>

                <td className="fw-semibold">{data.empName}</td>

                <td className="text-success fw-bold">
                  {data.slot1}
                </td>

                <td
                  className="fw-bold"
                  style={{
                    color: data.slot2 > 0 ? "#0d6efd" : "#212529",
                  }}
                >
                  {data.slot2}
                </td>

                <td
                  className="fw-bold"
                  style={{
                    color: data.slot3 > 0 ? "#dc3545" : "#212529",
                  }}
                >
                  {data.slot3}
                </td>

                <td>
                  <span
                    className="badge"
                    style={{
                      backgroundColor: "#198754",
                      fontSize: "14px",
                      padding: "8px 12px",
                      borderRadius: "8px",
                    }}
                  >
                    {Number(data.slot1) +
                      Number(data.slot2) +
                      Number(data.slot3)}
                  </span>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  </div>
</div>
                </div>

            </div>
        </>
    )
}

export default BsecHrDashboard;